import ReusableButton from 'components/commom/Button';
import Loader from 'components/commom/Loader';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import { getQuestionnaireListData } from 'store/QuestionnaireList/QuestionnaireListAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/system';
import EditCategory from 'assets/images/Dashboard/edit-practice.svg';
import DeleteList from 'assets/images/Dashboard/delete.svg';
import { questionnaireDetail } from 'routes/AppUrls';
import { deleteQuestionnaireData } from 'store/questionnaireDelete/questionnaireDeleteAction';
import {
  basicDetailsValue,
  QUESTIONAIRE_ID,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import { postQuestionnaireRequest } from 'store/createQuestionnaire/createQuestionnairAction';
import CommonModal from 'components/commom/Modal';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import CheckValidation from 'utils/validate';
import { getQuestionnaireDetailData } from 'store/getQestionnaireDetail/getQuestionnaireDetailAction';
import { updateQuestionnaire } from 'store/updateQuestionnaire/updateQuestionnaireAction';
import ReusablePagination from 'components/commom/Pagination';
import CommonToast from 'components/commom/CommonToast';
import { getMasterData } from 'store/masterData/masterDataAction';
import { getCategoryListData } from 'store/categoryList/categoryListAction';

const StyledAccordion = styled(Accordion)({
  boxShadow: 'none',
  borderBottom: true,
  marginBottom: '15px',
  backgroundColor: '#FFFFFF',
});

const StyledAccordionSummary = styled(AccordionSummary)({
  padding: '16px 16px 0 16px',
});

const StyledAccordionDetails = styled(AccordionDetails)({
  padding: '16px 16px 16px 32px',
});

const CategoryText = styled('div')(() => ({
  fontSize: '18px',
  fontFamily: 'outfit_medium;',
  fontWeight: 500,
  color: '#202224',
  lineHeight: '22.68px',
}));

const CategorySubHeading = styled('div')(() => ({
  fontSize: '16px',
  fontFamily: 'outfit_medium;',
  fontWeight: 500,
  color: '#202224',
  lineHeight: '20.16px',
}));

const QuestionType = styled('div')(() => ({
  fontSize: '14px',
  fontFamily: 'outfit_regular;',
  fontWeight: 400,
  color: '#A4AAB2',
  lineHeight: '17.64px',
}));

const QuestionValue = styled('div')(() => ({
  fontSize: '14px',
  fontFamily: 'outfit_medium;',
  fontWeight: 500,
  color: '#202224',
  lineHeight: '17.64px',
}));

const Questionnaire = () => {
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [questionnaireList, setQuestionnaireList] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [isError, setIsError] = useState(false);
  const [formValue, setFormValue] = useState({
    categoryName: '',
  });
  const [editMode, setEditMode] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const itemsPerPage = 10;

  const questionnaireLoading = useSelector(
    (state) => state?.questionnaireListDataReducer?.loading
  );

  const createReducer = useSelector(
    (state) => state?.postQuestionnaireReducer?.loading
  );

  const updateReducer = useSelector(
    (state) => state?.updateQuestionnaireReducer?.loading
  );

  const loading = useSelector(
    (state) => state?.deleteQuestionnairListReducer?.loading
  );

  const [questionnaireModal, setQuestionnaireModal] = useState(false);

  const handleChange = (panel, key) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    getQuestionnaireData();
    typeSelectData();
    categoryData();
  }, []);

  const getQuestionnaireData = (pageValue) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setQuestionnaireList(res?.data);
        setCount(Math.ceil(res?.count / itemsPerPage));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getQuestionnaireListData(external, pageValue));
  };

  const typeSelectData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {},
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getMasterData(external, 'question-type'));
  };

  const categoryData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {},
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getCategoryListData(external));
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    getQuestionnaireData(value);
  };

  const handleQuestion = (id) => {
    dispatch(basicDetailsValue(QUESTIONAIRE_ID, id));
    navigate(questionnaireDetail(locale));
  };

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setDeleteId('');
  };

  const deleteQuestionnaireValue = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        handleCloseDeleteModal();
        getQuestionnaireData();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(deleteQuestionnaireData(external, deleteId));
  };

  const handleQuestionnaireModal = (id) => {
    setQuestionnaireModal(true);
    if (id) {
      questionnaireDetailModal(id);
      setEditMode(id);
    }
  };

  const questionnaireDetailModal = (id) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setFormValue((prev) => ({
          ...prev,
          categoryName: res?.data?.title,
        }));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getQuestionnaireDetailData(external, id));
  };

  const handleCloseQuestionnaireModal = () => {
    setQuestionnaireModal(false);
  };

  const handleInputChange = (event) => {
    const value = event?.target?.value;
    setFormValue((prev) => ({
      ...prev,
      categoryName: value,
    }));
  };

  const handleQuestionnaire = () => {
    if (editMode) {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          setQuestionnaireModal(false);
          getQuestionnaireData();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      const error = CheckValidation(formValue);
      setIsError(error);
      if (error.submit) {
        let body = {
          title: formValue?.categoryName,
        };
        dispatch(updateQuestionnaire(external, body, editMode));
      }
    } else {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          setQuestionnaireModal(false);
          getQuestionnaireData();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      const error = CheckValidation(formValue);
      setIsError(error);
      if (error.submit) {
        let body = {
          title: formValue?.categoryName,
        };
        dispatch(postQuestionnaireRequest(external, body));
      }
    }
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0 pb-20">
            <FormattedMessage id="Questionnaire" />
          </h2>
          <Row className="m-0 p-0 ">
            <Col md={12} className="p-0 ">
              <Stack
                direction="horizontal"
                gap={2}
                className="flex justify-end"
              >
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#3C3C3C"
                  fontSize="16px"
                  fontWeight="500"
                  padding="14px 24px"
                  borderRadius="0px"
                  height="44px"
                  bgColor="transparent"
                  brColor="#3C3C3C"
                  fontFamily="outfit_medium"
                  onClick={() => handleQuestionnaireModal()}
                >
                  Add New Category
                </ReusableButton>
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="500"
                  padding="14px 24px"
                  borderRadius="0px"
                  height="44px"
                  bgColor="#864629"
                  brColor="#864629"
                  fontFamily="outfit_medium"
                  onClick={() => handleQuestion()}
                >
                  Add New Question
                </ReusableButton>
              </Stack>
            </Col>
          </Row>
          {questionnaireLoading ? (
            <Loader />
          ) : questionnaireList && questionnaireList.length > 0 ? (
            <div className="pt-20">
              <Row className="m-0">
                <Col md={12} className="p-0">
                  {questionnaireList &&
                    questionnaireList.length > 0 &&
                    questionnaireList.map((item, index) => (
                      <StyledAccordion
                        key={index}
                        expanded={expanded === 'panel' + index}
                        onChange={handleChange('panel' + index, item)}
                        defaultExpanded={false}
                      >
                        <StyledAccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              sx={{
                                width: '24px',
                                height: '24px',
                                color: '#3C3C3C',
                              }}
                            />
                          }
                          onClick={(event) => event.stopPropagation()}
                        >
                          <Stack
                            direction="horizontal"
                            gap={3}
                            className="flex items-center p-0"
                          >
                            <CategoryText>{item?.title}</CategoryText>
                            <Image
                              src={EditCategory}
                              onClick={(event) => {
                                event.stopPropagation();
                                handleQuestionnaireModal(item?.id);
                              }}
                            />
                          </Stack>
                        </StyledAccordionSummary>
                        {item?.question_list &&
                          item?.question_list.length > 0 &&
                          item.question_list.map(
                            (questionItem, questionIndex) => (
                              <StyledAccordionDetails key={questionIndex}>
                                <Row className="m-0">
                                  <Col md={8} className="p-0">
                                    <CategorySubHeading>
                                      {questionItem?.question_text}
                                    </CategorySubHeading>
                                  </Col>
                                  <Col md={4} className="p-0 flex justify-end">
                                    <Stack direction="horizontal" gap={2}>
                                      <Image
                                        src={DeleteList}
                                        className="cursor-pointer ..."
                                        onClick={() =>
                                          handleDeleteModal(questionItem?.id)
                                        }
                                      />
                                      <Image
                                        src={EditCategory}
                                        className="cursor-pointer ..."
                                        onClick={() =>
                                          handleQuestion(questionItem?.id)
                                        }
                                      />
                                    </Stack>
                                  </Col>
                                </Row>
                                <Stack
                                  direction="horizontal"
                                  gap={3}
                                  className="flex items-center pt-12 border-b pb-12 border-custom-gray"
                                >
                                  <Stack direction="horizontal" gap={2}>
                                    <QuestionType>Question type:</QuestionType>
                                    <QuestionValue>
                                      {questionItem?.question_type}
                                    </QuestionValue>
                                  </Stack>
                                  <Stack direction="horizontal" gap={2}>
                                    <QuestionType>Category:</QuestionType>
                                    <QuestionValue>
                                      {questionItem?.category}
                                    </QuestionValue>
                                  </Stack>
                                </Stack>
                              </StyledAccordionDetails>
                            )
                          )}
                      </StyledAccordion>
                    ))}
                </Col>
              </Row>
            </div>
          ) : (
            <div className="flex justify-center pt-120">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center pt-30">
                  Nothing here yet practice list
                </div>
              </div>
            </div>
          )}
          {count > 1 && (
            <Col sm={12} className="flex justify-end mt-10 p-0">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </Col>
          )}
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'810px'}
        modalActive={questionnaireModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12} className="p-0">
                <div className="">
                  <p className="p-0 m-0 fs-20 fc-292D32 family_outfit_semiBold_600">
                    Add a Category
                  </p>
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-24">
                  <LabelWithInput
                    label="Category Name"
                    placeholder="Category Name"
                    name="categoryName"
                    type="text"
                    value={formValue?.categoryName}
                    onChange={(e) => handleInputChange(e)}
                    errorText={
                      isError &&
                      isError?.categoryName?.error &&
                      isError?.categoryName?.errorMessage
                    }
                  />
                </div>
              </Col>
              <Col md={12} className="p-0 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="flex items-center pt-24"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#2C2C2C"
                    fontSize="16px"
                    fontWeight="400"
                    padding="14px 55px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#2C2C2C"
                    fontFamily="outfit_regular"
                    onClick={() => handleCloseQuestionnaireModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>
                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      (!updateReducer || !createReducer) &&
                        handleQuestionnaire();
                    }}
                    loading={updateReducer || createReducer}
                  >
                    <FormattedMessage id="Create" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={deleteModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseDeleteModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !loading && deleteQuestionnaireValue();
                    }}
                    loading={loading}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default Questionnaire;
